import { render } from "./learningExam.vue?vue&type=template&id=1afaed6a&scoped=true"
import script from "./learningExam.vue?vue&type=script&lang=js"
export * from "./learningExam.vue?vue&type=script&lang=js"

import "./learningExam.vue?vue&type=style&index=0&id=1afaed6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afaed6a"]])

export default __exports__